"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IVirtualElement.js.map